<mat-tab-group animationDuration="0ms" (selectedTabChange)="changeTabActions($event)" [selectedIndex]="1">
  <mat-tab label="{{ 'field.dataSources' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-data-sources [additionalDatatableRefresh]="dataSourcesTabSelect$"></app-data-sources>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'field.endpoints' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-widget-requests [additionalDatatableRefresh]="widgetRequestsTabSelect$"></app-widget-requests>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'widget.tableView.nameWithWidget' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <table-view-widget-mappings
          [additionalDatatableRefresh]="tableViewWidgetMappingTabSelect$"
        ></table-view-widget-mappings>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'widget.formIo.nameWithWidget' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-form-autofill [additionalDatatableRefresh]="formAutofillTabSelect$"></app-form-autofill>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
